import React from "react";
import styles from "./Disclaimers-ThirdParty.module.less";
import MiniMiranda from "assets/scripts/components/presentational/MiniMiranda/MiniMiranda";
const Disclaimers = ({ disclaimers, disclaimerIdMap }) => {
    return (<div className="vr vr_x4">
			<div className="text">
				<MiniMiranda />
				<ol>
					{disclaimers.map((disclaimer, index) => {
        const id = disclaimerIdMap[disclaimer];
        return (<li key={index} id={`Disclaimer${id}`} style={{ paddingTop: "10px" }} tabIndex={-1}>
								<span className={styles.disclaimerId}>
									[{id}]{" "}
								</span>
								<span dangerouslySetInnerHTML={{ __html: disclaimer }}/>
							</li>);
    })}
				</ol>
			</div>
		</div>);
};
export default Disclaimers;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/ImportantInformation/Disclaimers/Disclaimers-ThirdParty.tsx